import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromUserReducer from '../reducers/user.reducer';

export const selectUser = createFeatureSelector<fromUserReducer.UserState>('user');

export const getUserData = createSelector(selectUser, fromUserReducer.selectUserData);

export const getUserLoading = createSelector(selectUser, fromUserReducer.selectUserLoading);

export const getUserLoaded = createSelector(selectUser, fromUserReducer.selectUserLoaded);
